export const estAnnualSale = {
  min: 0,
  max: 1000000000,
  default: 500000000,
};

export const onlinePctSale = {
  min: 0,
  max: 100,
  default: 20,
};

export const industryAvg = {
  min: 0,
  max: 100,
};

export const markdownAvg = {
  min: 0,
  max: 10,
};

export const shippingAvg = {
  min: 0,
  max: 20,
};

export const medPct = {
  incOnlineSales: 0.02,
  incStoreSaleReduce: 0.4,
  reduceReturn: 0.0037,
  reduceMarkdownCosts: 0.3,
  reduceShippingCosts: 0.075,
};

export const lowPct = {
  incOnlineSales: 0.01,
  incStoreSaleReduce: 0.3,
  reduceReturn: 0.0025,
  reduceMarkdownCosts: 0.2,
  reduceShippingCosts: 0.05,
};

export const hightPct = {
  incOnlineSales: 0.03,
  incStoreSaleReduce: 0.5,
  reduceReturn: 0.005,
  reduceMarkdownCosts: 0.4,
  reduceShippingCosts: 0.1,
};

export const AvgOOSRate = 0.07;

export const SKELETON_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAQAAADYv8WvAAAAEElEQVR42mN8+p+BgRFEAAAWrwPLzYNPyAAAAABJRU5ErkJggg==';

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30SIPROI = '30BQJ';
